// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DictionaryEnumDto } from '../models';
/**
 * DictionariesApi - axios parameter creator
 */
export const DictionariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enums list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnums: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionaries/enums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesApi - functional programming interface
 */
export const DictionariesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionariesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enums list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnums(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryEnumDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnums(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.getEnums']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionariesApi - factory interface
 */
export const DictionariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionariesApiFp(configuration)
    return {
        /**
         * 
         * @summary Enums list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnums(options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryEnumDto>> {
            return localVarFp.getEnums(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionariesApi - interface
 */
export interface DictionariesApiInterface {
    /**
     * 
     * @summary Enums list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnums(options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryEnumDto>>;

}

/**
 * DictionariesApi - object-oriented interface
 */
export class DictionariesApi extends BaseAPI implements DictionariesApiInterface {
    /**
     * 
     * @summary Enums list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEnums(options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).getEnums(options).then((request) => request(this.axios, this.basePath));
    }
}

